// Side-effect module: applies stored cookie consent before any analytics
// provider initializes. Import this BEFORE firebase or other analytics modules.
import { applyStoredConsent } from './consent-utils';

applyStoredConsent();
